import { Type } from 'class-transformer';
import { GLBatchSummaryItemResultDto } from './gl-batch-summary-item-result-dto';

export class GLBatchSummaryResultDto {
    @Type(() => GLBatchSummaryItemResultDto)
    items: GLBatchSummaryItemResultDto[];

    managementCompanyId: number;
    communityId: number;
    batchId: number;
    batchName: string;

    @Type(() => Date)
    postDate: Date;

    totalDebitAmount: number;
    totalCreditAmount: number;
}
